import { IPage } from '../../types/page';

const initialState: IPage = {
  isMyHomePage: false,
};

export const pageReducer = (state: IPage = initialState) => state;
